module.exports = __webpack_public_path__ + "static/card-football-39fd67910fbcfa0221336a9099c0c26f.webp";